<!-- Start: View head -->
<div class="view-head global-visit-list">
  <div class="row">

    <div class="col-12 d-none d-md-block col-md-3">
      <h2>Project Management</h2>
    </div>

    <div class="col-12 col-md-9 text-right">
      <div class="button-container">
        <app-button text="Export" (clicked)="showExportModal()" />
      </div>

      <form [formGroup]="searchForm">
        <app-search-input #searchInput name="searchTerm" [parentForm]="searchForm"
          (inputChange)="onSearchInputChanged($event)"></app-search-input>
      </form>

      <div class="filter-button" *ngIf="selectedTab === 'trips_expenses'">
        <app-button variant="secondary" [iconOnly]="true" faIcon="fas fa-filter" (click)="filterModal.show()" />
      </div>


      <app-dropdown-input #orderBySelect class="order-by-dropdown" *ngIf="selectedTab === 'over_budget_requests'"
        [options]="orderByOptions">
      </app-dropdown-input>

      <div class="filter-toggle-container">
        <app-filter-toggle [options]="filterOptions" (toggled)="onFilterToggle($event)"></app-filter-toggle>
      </div>
    </div>

  </div>
</div>
<!-- End: View head -->

<div class="view-body global-visits">

  <div class="tabs-wrap">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab === 'trips_expenses'}"
          (click)="onTabClick('trips_expenses')">
          Reimbursement and Travel
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab === 'over_budget_requests'}"
          (click)="onTabClick('over_budget_requests')">
          Over budget requests
        </a>
      </li>
    </ul>
  </div>

  <div class="content-panel">
    <div *ngIf="selectedTab === 'trips_expenses'" class="horizontal-scroll">
      <table class="pgo-data-grid full-width" aria-hidden="true">
        <thead>
          <tr>
            <th>Patient ID</th>
            <th>Trial Code</th>
            <th>Visit Title</th>
            <th>Date of Visit</th>
            <th>Purpose</th>
            <th>Type</th>
            <th>Quoted Am. (LC)</th>
            <th>Quoted Cur. (LC)</th>
            <th>Quoted Am. (BC)</th>
            <th>Quoted Cur. (BC)</th>
            <th>Invoiced Am. (LC)</th>
            <th>Invoiced Cur. (LC)</th>
            <th>Invoiced Am. (BC)</th>
            <th>Invoiced Cur. (BC)</th>
            <th>Invoice No.</th>
            <th>Payment Method</th>
            <th>Notes</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of results.results; let i = index">
            <td class="plain-text">{{result.patientCode}}</td>
            <td class="plain-text">{{result.trialCode}}</td>
            <td class="plain-text">{{result.visitTitle}}</td>
            <td class="plain-text">{{result.visitDate | date: 'd MMM yyyy'}}</td>
            <td class="plain-text">{{result.type === 'Travel' ? displayTravelPurpose(result.purpose) : result.purpose}}
            </td>
            <td class="plain-text">{{result.type}}</td>
            <td *ngIf="forms.length" table-cell-amount class="col-amount" controlName="quotedAmount"
              (valueChanged)="onQuotedAmountChanged(i, result.type)" [editable]="false"
              [negativeAmount]="result.subCategory === ExpenseSubCategory.CardPreloadRedemption"
              [amount]="result.quotedAmount !== null ? result.quotedAmount.toString() : ''" [parentForm]="forms[i]">
            </td>
            <td *ngIf="forms.length" table-cell-currency class="col-currency" controlName="quotedCurrency"
              (valueChanged)="onQuotedCurrencyChanged(i, result.type)" [parentForm]="forms[i]" [editable]="false">
            </td>
            <td *ngIf="forms.length" table-cell-amount class="col-amount" controlName="quotedAmountBc"
              (valueChanged)="onQuotedAmountBcChanged(i, result.type)" [editable]="false"
              [negativeAmount]="result.subCategory === ExpenseSubCategory.CardPreloadRedemption"
              [amount]="result.quotedAmountBC !== null ? result.quotedAmountBC.toString() : ''" [parentForm]="forms[i]">
            </td>
            <td class="plain-text">{{result.baseCurrency}}</td>
            <td *ngIf="forms.length" table-cell-amount class="col-amount" controlName="invoicedAmount"
              (valueChanged)="onInvoicedAmountChanged(i)"
              [negativeAmount]="result.subCategory === ExpenseSubCategory.CardPreloadRedemption"
              [editable]="(authService.hasRole(roleNames.ProjectManager) || authService.hasRole(roleNames.ProductAdministrator)) && result.type !== 'Reimbursement'"
              [amount]="result.invoicedAmount !== null ? result.invoicedAmount.toString() : ''" [parentForm]="forms[i]">
            </td>
            <td *ngIf="forms.length" table-cell-currency class="col-currency" controlName="invoicedCurrency"
              (valueChanged)="onInvoicedCurrencyChanged(i)" [parentForm]="forms[i]"
              [editable]="(authService.hasRole(roleNames.ProjectManager) || authService.hasRole(roleNames.ProductAdministrator)) && result.type !== 'Reimbursement'">
            </td>
            <td *ngIf="forms.length" table-cell-amount class="col-amount" controlName="invoicedAmountBc"
              (valueChanged)="onInvoicedAmountBcChanged(i)"
              [negativeAmount]="result.subCategory === ExpenseSubCategory.CardPreloadRedemption"
              [editable]="(authService.hasRole(roleNames.ProjectManager) || authService.hasRole(roleNames.ProductAdministrator)) && result.type !== 'Reimbursement'"
              [amount]="result.invoicedAmountBC !== null ? result.invoicedAmountBC.toString() : ''"
              [parentForm]="forms[i]">
            </td>
            <td class="plain-text">{{result.baseCurrency}}</td>
            <td *ngIf="forms.length" table-inline-cell-text class="col-invoice-no" controlName="invoiceNumber"
              (valueChanged)="onInvoiceNumberChanges(i)" [text]="forms[i].get('invoiceNumber').value"
              [editable]="(authService.hasRole(roleNames.ProjectManager) || authService.hasRole(roleNames.ProductAdministrator)) && result.type !== 'Reimbursement'"
              [parentForm]="forms[i]">
            </td>
            <td class="plain-text">{{displayPaymentMethod(result.paymentMethod)}}</td>
            <td class="plain-text">{{result.notes}}</td>
            <td class="plain-text">{{displayStatus(result.type, result.status)}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="selectedTab === 'over_budget_requests'">
      <table class="pgo-data-grid full-width" aria-hidden="true">
        <thead>
          <tr>
            <th>Date raised</th>
            <th>Patient ID</th>
            <th>Trial Code</th>
            <th>Visit title</th>
            <th>Visit date</th>
            <th>Oracle code</th>
            <th>Category</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody *ngIf="overBudgetRequests">
          <ng-container *ngFor="let overBudgetRequest of overBudgetRequests.results">
            <tr class="over-budget-row">
              <td class="plain-text">
                <mat-icon (click)="getOverBudgetRequestItems(overBudgetRequest.id)"
                  *ngIf="!overBudgetRequestItemsLoading[overBudgetRequest.id] && !showOverBudgetRequestItems[overBudgetRequest.id]">expand_more</mat-icon>
                <mat-icon (click)="hideOverBudgetRequestItems(overBudgetRequest.id)"
                  *ngIf="!overBudgetRequestItemsLoading[overBudgetRequest.id] && showOverBudgetRequestItems[overBudgetRequest.id]">expand_less</mat-icon>
                <span *ngIf="overBudgetRequestItemsLoading[overBudgetRequest.id]" class="loader">
                  <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
                </span>
                {{overBudgetRequest.dateRaised | date: 'dd/MM/yy'}}
              </td>
              <td class="plain-text">{{overBudgetRequest.patientId}}</td>
              <td class="plain-text">{{overBudgetRequest.trialCode}}</td>
              <td class="plain-text">{{overBudgetRequest.visitTitle}}</td>
              <td class="plain-text">{{overBudgetRequest.visitDate | date: 'dd/MM/yy'}}</td>
              <td class="plain-text">{{overBudgetRequest.oracleCode}}</td>
              <td class="plain-text">{{overBudgetRequest.category | enumToText: OverBudgetRequestCategory}}</td>
              <td class="plain-text">{{overBudgetRequest.status | enumToText: OverBudgetRequestStatus}}</td>
            </tr>
            <tr>
              <td colspan="8">
                <app-over-budget-request-items *ngIf="showOverBudgetRequestItems[overBudgetRequest.id]"
                  [overBudgetRequest]="overBudgetRequest"
                  [overBudgetRequestItemsViewModel]="overBudgetRequestItemsViewModels[overBudgetRequest.id]"
                  [overBudgetRequestId]="overBudgetRequest.id" [patientTrialId]="overBudgetRequest.patientTrialId"
                  [overBudgetRequestCategory]="overBudgetRequest.category"
                  [sponsorEmailed]="overBudgetRequest.sponsorEmailed"
                  (deleteRequest)="onDeleteRequest(overBudgetRequest.id)"
                  (referBackRequest)="onReferBackRequest(overBudgetRequest.id)"
                  (refreshItems)="getOverBudgetRequestItems(overBudgetRequest.id, true)"
                  (sponsorEmailedChanged)="loadOverBudgetRequests(results.currentPage, $event)"
                  (overBudgetRequestClosed)="overBudgetRequest.status = OverBudgetRequestStatus.Closed">
                </app-over-budget-request-items>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <app-pagination
      [currentPage]="selectedTab === 'trips_expenses' ? results.currentPage : overBudgetRequests?.currentPage"
      [totalPageCount]="selectedTab === 'trips_expenses' ? results.totalPageCount : overBudgetRequests?.totalPageCount"
      (pageSelected)="onChangePage($event)">
    </app-pagination>
  </div>

</div>

<!-- Start: Filter modal -->
<app-modal #filterModal>
  <div class="modal-header">
    <h2 class="modal-title">Filter Visits</h2>
  </div>
  <div class="modal-body" [formGroup]="filterForm">
    <form class="modal-form-full-width" [formGroup]="filterForm">
      <div class="form-group">
        <label>Date Range Start</label>
        <app-datepickerv2-input [parentForm]="filterForm" controlName="startDate"></app-datepickerv2-input>
      </div>
      <div class="form-group">
        <label>Date Range End</label>
        <app-datepickerv2-input [parentForm]="filterForm" controlName="endDate"></app-datepickerv2-input>
      </div>
      <div class="form-group">
        <label>Patient</label>
        <app-patient-autocomplete #patientAutocomplete [parentForm]="filterForm"
          (selectionChanged)="onPatientSelected($event)" controlName="patientId"
          placeholder="Patient Name or Id..."></app-patient-autocomplete>
      </div>
      <div class="form-group" *ngIf="filterForm.get('patientId').value">
        <label>Visit</label>
        <app-dropdown-input #visitSelect [options]="patientVisits" [parentForm]="filterForm" name="visitId"
          placeholder="Select Visit..."></app-dropdown-input>
      </div>
      <div class="form-group">
        <label>Trial</label>
        <app-trial-autocomplete #trialAutocomplete (valueChanged)="onFilterTrialChanged($event)" [form]="filterForm"
          [patientId]="filterForm.get('patientId').value" controlName="trialCode"
          placeholder="Select a trial..."></app-trial-autocomplete>
      </div>
      <div class="form-group">
        <label>Type</label>
        <app-dropdown-input #typeSelect [options]="types" [parentForm]="filterForm" name="type"
          placeholder="Select type..."></app-dropdown-input>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" variant="secondary" width="fill" (clicked)="filterModal.hide()" />
      </div>

      <div class="col-6">
        <app-button text="Apply Filter" [isBusy]="filterForm.get('processing')?.value" width="fill"
          (clicked)="onFilterData()" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <app-button text="Reset Filter" variant="link" width="fill" (clicked)="onResetFilter()" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Filter modal -->

<!-- Start: Export modal -->
<app-modal #exportModal>
  <div class="modal-header">
    <h2 class="modal-title">Export</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="exportForm">
      <div class="form-group" [class.visibility-hidden]="exportForm.get('allData').value == true">
        <label>Date Range Start</label>
        <app-datepickerv2-input [parentForm]="exportForm" controlName="startDate"></app-datepickerv2-input>
      </div>

      <div class="form-group" [class.visibility-hidden]="exportForm.get('allData').value == true">
        <label>Date Range End</label>
        <app-datepickerv2-input [parentForm]="exportForm" controlName="endDate"></app-datepickerv2-input>
      </div>

      <div class="form-group" [class.visibility-hidden]="exportForm.get('allTrials').value === true">
        <label>Trial<span class="required-star">*</span></label>
        <app-trial-autocomplete #exportTrialAutocomplete (valueChanged)="onExportTrialChanged($event)"
          (cleared)="onExportTrialCleared()" [form]="exportForm" controlName="trialId"
          placeholder="Select a trial..."></app-trial-autocomplete>
      </div>

      <div class="form-group" *ngIf="selectedTrialBrandName !== 'adarx'">
        <label class="checkbox">
          <input formControlName="allTrials" id="all-trials" type="checkbox" value="true">
          <span></span>
        </label>
        <label class="checkbox-label" for="all-trials">All trials</label>
      </div>

      <div class="form-group"
        [class.visibility-hidden]="!exportForm.get('trialId').value && !exportForm.get('allTrials').value">
        <label>What to Export</label>
        <app-input-select #exportTypeSelect [items]="exportTypeOptions" [parentForm]="exportForm" controlName="type"
          inputPlaceholder="Select what to export..."></app-input-select>
      </div>

      <div [class.visibility-hidden]="!exportShouldShowSiteDropdown()">
        @if (exportForm.get('type').value === 'generic-diary' && diaryForms.length > 0) {
        <div class="form-group">
          <label>E-Diary Form</label>
          <mat-select formControlName="diaryFormId" placeholder="Select diary form..." hideSingleSelectionIndicator>
            <mat-option *ngFor="let form of diaryForms" [value]="form.id">{{ form.name }}</mat-option>
          </mat-select>
        </div>
        }

        <div class="form-group" [class.visibility-hidden]="exportForm.get('allSites').value === true">
          <label>Site</label>
          <app-site-dropdown formControlName="siteId" [trialId]="this.exportForm.get('trialId').value"
            [trialIdRequired]="true" [approvedOnly]="true" [assignedOnly]="true" [unassignedOnly]="false" />
        </div>

        <div class="form-group">
          <label class="checkbox">
            <input formControlName="allSites" id="all-sites" type="checkbox" value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="all-sites">All sites</label>
        </div>

        <div class="form-group">
          <label class="checkbox">
            <input formControlName="allData" id="all-data" type="checkbox" value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="all-data">All available data (ignore date range)</label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" variant="secondary" width="fill" (clicked)="onHideExportModal()" />
      </div>

      <div class="col-6">
        <app-button text="Export" width="fill" [disabled]="exportForm.invalid || processingRequest"
          [isBusy]="processingRequest" (clicked)="export()" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Export modal -->

<app-modal #confirmDeleteModal>
  <div class="modal-header">
    <h2 class="modal-title">Delete request?</h2>
  </div>
  <div class="modal-body">
    <form [formGroup]="deleteOverBudgetRequestForm">
      <div class="form-group">
        <label>Reason for deletion</label>
        <textarea style="width: 100% !important" class="form-control" formControlName="notes" type="text"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="No" variant="secondary" width="fill" (clicked)="confirmDeleteModal.hide()" />
      </div>
      <div class="col-6">
        <app-button text="Yes" width="fill" [disabled]="loading || deleteOverBudgetRequestForm.invalid"
          [isBusy]="loading" (clicked)="deleteOverBudgetRequest()" />
      </div>
    </div>
  </div>
</app-modal>

<app-modal #referBackOverBudgetRequestModal>
  <div class="modal-header">
    <h2 class="modal-title">Refer back over budget request ?</h2>
  </div>
  <div class="modal-body">
    <form [formGroup]="referBackOverBudgetRequestForm">
      <div class="form-group">
        <label>Notes</label>
        <textarea style="width: 100% !important" class="form-control" formControlName="notes" type="text"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="No" variant="secondary" width="fill" (clicked)="referBackOverBudgetRequestModal.hide()" />
      </div>
      <div class="col-6">
        <app-button text="Yes" width="fill" [disabled]="loading || referBackOverBudgetRequestForm.invalid"
          [isBusy]="loading" (clicked)="referBackOverBudgetRequest()" />
      </div>
    </div>
  </div>
</app-modal>